import { SupplierStatus } from "models/supplier"

export const NEGOTIATION_TYPES = ["CPP", "NEGOTIATED"] as const

export type RateCard = {
  id: string
  status: SupplierStatus
  name: string
  effectiveDate: string
  mediaTypeName?: string
  mediaTypeId?: string
  supplierProducts?: { id: string; name: string }[]
  mediaOwnerName?: string
  clientId?: string
  negotiationType: (typeof NEGOTIATION_TYPES)[number]
}

export type RateCardDetails = {
  id: string
  status: SupplierStatus
  name: string
  effectiveDate: string
  //
  mediaTypeId?: string
  mediaTypeName?: string
  //
  supplierId?: string
  supplierName?: string
  //
  loading?: boolean
  loadings?: RateCardLoading[]
  //
  mediaOwnerId?: string
  mediaOwnerName?: string
  //
  supplierProducts?: (RateCardSupplierProduct | null)[]
  locations?: RateCardLocation[]
  //
  clientId?: string
  negotiationType: "CPP" | "NEGOTIATED"
}

export type RateCardLoading = {
  id?: string
  rateCardId?: string
  description?: string
  percentage?: number
  validationPeriodStart?: string
  validationPeriodEnd?: string
}

export type RateCardSupplierProduct = {
  id: string
  name: string
}

export type RateCardLocation = {
  location: string // unique, use as id
  supplierProductId?: string
}

export type BaseRate = {
  id: string
  rateCardId: string
  supplierProductId: string
  location?: string
  //
  dimensions?: Dimension[]
  data?: BaseRateRowRecord[]
}

export type Dimension = {
  mediaFieldSemanticCode: string
  enabled: boolean
  options: DimensionOption[]
}

export type DimensionOptionType = "PERCENTAGE" | "MANUAL"
export type DimensionOption = {
  type: DimensionOptionType
  value: string | number
  percentage?: number
  isDefault?: boolean
}

export interface BaseRateRowRecord extends Record<string, any> {
  id: string
  duration: Record<string, number>
}
